(() => {
  if (window.__ptAutumnDeal) return;
  window.__ptAutumnDeal = true;
  const pad = value => String(value).padStart(2, '0');
  const tick = () => {
    const now = Date.now();
    let active = false;
    document.querySelectorAll('[data-pt-autumn-deal]').forEach(root => {
      const start = Date.parse(root.dataset.start);
      const end = Date.parse(root.dataset.end);
      const valid = Number.isFinite(start) && Number.isFinite(end) && now >= start && now < end;
      root.hidden = !valid;
      if (!valid) return;
      active = true;
      root.querySelectorAll('[data-pt-autumn-clock]').forEach(clock => {
        const remaining = Math.max(0, Math.ceil((end - now) / 1000));
        const days = Math.floor(remaining / 86400);
        const hours = Math.floor(remaining % 86400 / 3600);
        const minutes = Math.floor(remaining % 3600 / 60);
        const seconds = remaining % 60;
        clock.textContent = `${days}${clock.dataset.daysLabel || 'T'} ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      });
    });
    document.querySelectorAll('[data-pt-autumn-ended]').forEach(node => { node.hidden = active; });
  };
  const legacyIds = ['T8ycZ4', 'YcpTU7', 'TRSPLB', 'RvKj2U'];
  const legacySelector = legacyIds.map(id => `[class*="klaviyo-form-${id}"]`).join(',');
  const popupSelector = '[role="dialog"],[data-testid*="POPUP" i],[class*="klaviyo" i]';
  const competing = /neukunden(?:rabatt|bonus|gutschein)?|(?:deine|die) erste bestellung|2\s+zubehörteile\s+gratis|(?:5|10|15|18|20)\s*%\s*(?:rabatt|auf)/i;
  const hideLegacy = node => {
    if (!(node instanceof HTMLElement) || node.closest('[data-pt-autumn-deal]')) return;
    if (node.tagName === 'BODY' || node.tagName === 'HTML') return;
    node.style.setProperty('display', 'none', 'important');
    node.setAttribute('aria-hidden', 'true');
  };
  const inspect = root => {
    if (!(root instanceof Element)) return;
    if (root.matches(legacySelector)) hideLegacy(root);
    root.querySelectorAll(legacySelector).forEach(hideLegacy);
    const inspectPopup = node => {
      if (!competing.test(node.textContent || '') || node.closest('[data-pt-autumn-deal]')) return;
      let current = node;
      for (let depth = 0; current && depth < 6; depth++, current = current.parentElement) {
        if (current.tagName === 'BODY' || current.tagName === 'HTML') break;
        if (getComputedStyle(current).position === 'fixed') { hideLegacy(current); break; }
      }
    };
    if (root.matches(popupSelector)) inspectPopup(root);
    root.querySelectorAll(popupSelector).forEach(inspectPopup);
    const ancestor = root.closest(popupSelector);
    if (ancestor) inspectPopup(ancestor);
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-pt-autumn-copy]');
    if (!button || button.closest('[data-pt-autumn-deal]')?.hidden) return;
    const code = button.dataset.ptAutumnCopy;
    let copied = false;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
        copied = true;
      }
    } catch (error) {}
    if (!copied) {
      const field = document.createElement('textarea');
      field.value = code;
      field.setAttribute('readonly', '');
      field.style.cssText = 'position:fixed;left:-9999px;top:0';
      document.body.appendChild(field);
      field.select();
      try { copied = document.execCommand('copy'); } catch (error) {}
      field.remove();
      button.focus({ preventScroll: true });
    }
    const status = button.nextElementSibling;
    const label = button.querySelector('[data-pt-copy-label]');
    const message = copied ? button.dataset.copiedLabel : button.dataset.fallbackLabel;
    if (status?.matches('[data-pt-copy-status]')) status.textContent = message;
    if (label) label.textContent = message;
    if (!copied) {
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(button.querySelector('.pt-autumn-code__value'));
      selection.removeAllRanges();
      selection.addRange(range);
    }
    if (button._ptCopyTimer) clearTimeout(button._ptCopyTimer);
    button._ptCopyTimer = setTimeout(() => {
      if (label) label.textContent = button.dataset.copyLabel;
      if (status?.matches('[data-pt-copy-status]')) status.textContent = '';
    }, 2500);
  });
  const init = () => {
    tick();
    inspect(document.body);
  };
  init();
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', init);
  const pending = new Set();
  let scheduled = false;
  new MutationObserver(entries => {
    entries.forEach(entry => {
      if (entry.target.closest?.('[data-pt-autumn-deal]')) return;
      entry.addedNodes.forEach(node => { if (node instanceof Element) pending.add(node); });
    });
    if (!pending.size || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      pending.forEach(inspect);
      pending.clear();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
